<template>
  <div class="messages">
    <com-title title="合作伙伴寄语"></com-title>
    <div class="container">
      <ul class="columns">
        <li v-for="(item, index) in messages" :key="index" class="column is-one-third-tablet">
          <a class="wrap" href="javascript:void(0)">
            <div class="content-wrapper">
              <div class="logo">
                <img :src="item.logo" alt="">
              </div>
              <div class="word">
                <div class="word-content">{{item.word}}</div>
                <div class="word-author">
                  <span>{{item.author}}</span>
                  <span>{{item.company}}</span>
                </div>
              </div>
            </div>
            <div class="hover">
              <span class="word-content">{{item.word}}</span>
              <!-- <div class="word-author">
                <span>{{item.author}}</span>
                <span>{{item.company}}</span>
              </div> -->
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import comTitle from '@/base/title'
export default {
  data () {
    return {}
  },
  components: {
    comTitle
  },
  props: ['messages']
}
</script>
<style scoped lang='sass'>
@import '../../style/variable.sass'

.messages
  background-color: #f5f5f5
  padding-bottom: 56px
  .container
    box-sizing: border-box
    +mobile
      width: 88vw
    ul
      flex-wrap: wrap
      align-items: stretch
      li
        a
          display: block
          padding: 0.75rem
          padding-top: 0
          height: 320px
          background-color: #fff
          box-shadow: 0px 4px 15px 0px rgba(7, 17, 27, 0.1)
          border-radius: 5px
          position: relative
          &:hover
            .hover
              opacity: 1
              background-color: #2663a0
              color: #fff
          .hover
            box-sizing: border-box
            position: absolute
            left: 0
            top: 0
            width: 100%
            height: 100%
            opacity: 0
            padding: 1.95rem
            font-size: 14px
            background-color: #fff
            transition: all 0.3s linear
            display: flex
            align-items: center
            justify-content: center
          +mobile
            height: auto
          .content-wrapper
            padding: 1.2rem
            padding-top: 0
            .logo
              border-bottom: 1px solid #ddd
              display: flex
              align-items: center
              justify-content: center
              height: 80px
              img
                height: 94%
            .word
              margin-top: 20px
              display: flex
              flex-direction: column
              align-items: flex-end
              .word-author
                font-size: 14px
                color: #888
                display: flex
                flex-direction: column
                align-items: flex-end
              .word-content
                font-size: 14px
                margin-bottom: 20px
                color: #353535
                +limit-line-numbers(6)
</style>
